import { EventEmitter, Injectable, OnDestroy } from '@angular/core';

export class FrameForm {
  status?: FrameStatus;
  info: string;
}

export enum FrameStatus {
  WIN = 'win',
  LOST = 'lost',
  OPEN = 'open',
  HINT = 'hint',
  ERROR = 'error',
}

@Injectable()
export class GameCanvasService implements OnDestroy {
  $displayInfo: EventEmitter<FrameForm> = new EventEmitter<FrameForm>();
  $toggleRulesOpen: EventEmitter<boolean> = new EventEmitter<boolean>();
  $hasBackgroundMusic: EventEmitter<boolean> = new EventEmitter<boolean>();
  $outcome: EventEmitter<number> = new EventEmitter<number>();

  constructor() {}

  public emitRuleOpen(open: boolean) {
    this.$toggleRulesOpen.emit(open);
  }

  public emitInfo(data: FrameForm) {
    this.$displayInfo.emit(data);
  }

  public hasBackgroundMusic(hasMusic: boolean) {
    this.$hasBackgroundMusic.emit(hasMusic);
  }

  ngOnDestroy() {}
}



// WEBPACK FOOTER //
// /var/lib/jenkins/workspace/Prod_web-client/src/app/_v2/games/game-canvas/services/game-canvas.service.ts